module.exports = __webpack_public_path__ + "img/invite.4d3bf9aa.png";